import { subscriptionsApi } from '~/shared/api'
import { SubscriptionListType } from '~/shared/constants/commonConstants'
import {
  IRawOneTimeSubscription,
  getOneTimeSubscriptionListFromRawSubscriptionList,
} from '~/shared/helpers/getOneTimeSubscriptionListFromRawSubscriptionList'
import { getSubscriptionListFromRawSubscriptionList } from '~/shared/helpers/getSubscriptionListFromRawSubscriptionList'
import { GET_SUBSCRIPTION_LIST } from '~/shared/store/common/actionTypes'
import { startFetching, stopFetching } from '~/shared/store/common/actions'
import { selectCohortID } from '~/shared/store/common/selects'
import { IAppState, TAppDispatchThunk } from '~/shared/store/types'
import { selectUserUUID } from '~/shared/store/user/selects'

import { setSubscriptionListAction } from './syncActions'

export function getSubscriptionListAction({
  tags,
  subscriptionType = SubscriptionListType.PURCHASE,
}: {
  tags: string
  subscriptionType?: typeof SubscriptionListType[keyof typeof SubscriptionListType]
}): any {
  return async (
    dispatch: TAppDispatchThunk<any>,
    getState: () => IAppState,
  ) => {
    const state = getState()
    const uuid = selectUserUUID(state)
    const cohort = selectCohortID(state)

    dispatch(startFetching(GET_SUBSCRIPTION_LIST))

    const response = await subscriptionsApi.getSubscriptionList({
      uuid,
      cohort,
      type: subscriptionType,
      tags,
    })

    if (response.success && response.data) {
      const subscriptionList =
        subscriptionType === SubscriptionListType.ONE_TIME
          ? getOneTimeSubscriptionListFromRawSubscriptionList(
              response.data.plans as unknown as IRawOneTimeSubscription,
            )
          : getSubscriptionListFromRawSubscriptionList(response.data.plans)

      dispatch(setSubscriptionListAction(subscriptionList))
    }

    dispatch(stopFetching(GET_SUBSCRIPTION_LIST))
  }
}
